export default __webpack_public_path__ + "static/media/29_photo.9a5d4804.jpg";